import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  notification,
  Row,
} from "antd";
import React from "react";
import { useClient } from "../../../Context/ClientContext";
import VendorRegistrationService from "../../../Services/Vendor/VendorRegistrationService";

const VendorRegRequest = () => {
  const { currentClient } = useClient();
  const [form] = Form.useForm();

  const sendRequest = () => {
    form.validateFields().then(async (val: any) => {
      console.log("val", val);

      let res = await VendorRegistrationService?.sendVendorRegRequest(
        currentClient?.id,
        val?.email
      );
      if (res?.status) {
        notification.success({
          message: "Success",
          description: "Email Request send successful.",
        });
      } else {
        notification.error({
          message: "Error",
          description: res?.message,
        });
      }
    });
  };

  return (
    <>
      <Card
        size="small"
        className="TableCard"
        style={{
          marginTop: 20,
          padding: 20,
          boxShadow: "0px 4px 15px rgba(150, 161, 200, 0.3)",
          borderRadius: "10px",
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{ maxWidth: "400px", margin: "0 auto", textAlign: "center" }}
        >
          <Form form={form} requiredMark={false}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Please enter a valid email!" },
              ]}
            >
              <Input
                type="email"
                placeholder="Enter your email address"
                style={{
                  height: "40px",
                  borderRadius: "5px",
                  border: "1px solid #d9d9d9",
                }}
              />
            </Form.Item>
          </Form>
          <Row justify="center">
            <Col>
              <Button
                type="primary"
                onClick={sendRequest}
                style={{
                  width: "150px",
                  height: "40px",
                  borderRadius: "5px",
                  fontWeight: "bold",
                  boxShadow: "0px 2px 6px rgba(24, 144, 255, 0.3)",
                  marginLeft: "55px",
                }}
              >
                Send Request
              </Button>
            </Col>
          </Row>
        </div>
      </Card>
    </>
  );
};

export default VendorRegRequest;
